<template>
    <div class="mianView">
        <div class="mianTop">
            <span class="mianTop_text">隐私政策和服务协议</span>
        </div>
        <div class="mianbody">
            <div class="scroll_wrapper" ref="wrapper">
                <div class="wrapper_main" ref="wrapper_main">
                        <div class="wrapper_span">{{topStr}}<br>{{topStr1}}<br>{{topStr2}}<a @click="toFuwu">《 服务协议》</a>和 <a @click="toYinsi">《隐私政策》</a>{{footStr}}</div>
                </div>
            </div>
        </div>
        <div class="mianfoot">
            <span @click="closeAction" class="mianfoot_text1">暂不使用</span>
            <span @click="doPost" class="mianfoot_text">同意并继续</span>
        </div>
    </div>
</template>
<script type="text/javascript">
 import {setAgreeByUserId ,saveWxAgree} from '../utils/api';
 import { mapState, mapActions } from "vuex";
 import storage from '../utils/storage'
export default {
  name: 'agreementPopup',

  props: {
  },
  data () {
    return {

        topStr:"欢迎您使用企业服务系统！我们对每一位用户的隐私权采取高度尊重且保护的态度。",
        topStr1:"1 .为了更好的提供园区物业及工作生活等相关服务，协助您排查使用过程中遇到的问题，我们会根据您在使用过程中的具体功能需要，申请必要的用户信息，如位置、手机号、微信账户等相关权限。",
        topStr2:"2 .您可以通过阅读",
        footStr:'，了解我们申请使用相关权限的情况， 以及对您个人隐私的保护措施。如果您点击"同意并继续"则视为您同意《隐私协议》 和《服务协议》的全部内容。',
        scroll:"",
    };
  },
   computed: {
        ...mapState({
            common: state => state.common
        })
   },
  mounted() {

    // 保证在DOM渲染完毕后初始化better-scroll
    // setTimeout(() => {
    //   this._initScroll();
    // }, 20);
  },
  created () {},
   methods: {
       ...mapActions(['getMarketInfo','getUserInfo',]),
       toFuwu(){

            this.$router.push({
                path: "/Service"
            });
       },

       toYinsi(){
            this.$router.push({
                path: "/agreeMent"
            });
       },
       doPost(){
            // if(this.common.userId){
                let params = { 
                    // userId:this.common.userId,
                    isAgree:1   //isAgree 1同意 0不同意
                };
              
                // console.log("userInfo == " +JSON.stringify(userInfo) )
                // setAgreeByUserId(params).then(res => {
                saveWxAgree(params).then(res => {
                    console.log(res);
                    // var op ={"openid":"oB0Dv08y-XBcnvZCQ73Om-qZBEE8"}
                    var userInfo = this.common.userInfo
                    var userData = JSON.parse(storage.getS("userData")) 
                    userInfo.isAgree =1
                    this.getUserInfo(userInfo)
                    if(userData){
                        userData.isAgree =1
                        storage.setS("userData",JSON.stringify(userData))
                        console.log('userData ===' + JSON.stringify(userData))
                    }
                    this.$emit('closePopup')
                })
            // }else{
            //     var userInfo =this.common.userInfo
            //     userInfo.isAgree =1
            //     this.getUserInfo(userInfo)
            //     this.$emit('closePopup')
            // }
       },
       closeAction(){
            // this.$router.go(-1)
             this.$router.replace('/blank')
       }

    },

}
</script>

<style lang="less" scoped>
@import "../assets/css/common.less";
.mianView{
    position: absolute;
    top:0px;
    left:10px;
    width: 580px;
    height: 726px;
    display: flex;
    background-color: white;
    transform:translate(-50%,-50%);
    flex-direction: column;
    border-radius: 8px;
}
.mianTop{
    height: 100px;
    width: 580px;
    display: flex;
    flex-direction: row;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.mianTop_text{
    font-size: 32px;
    font-weight: 500;
    color: #333333;
}
.mianbody{
    width: 580px;
    height: 526px;
    overflow: hidden;
    flex-direction: column;
}
.scroll_wrapper {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.wrapper_main {
  position: relative;
  height: 526px;
  flex-direction: row;
  flex-wrap: wrap;

}
.wrapper_span{
    margin-left: 30px;
    margin-right: 30px;
    font-size: 26px;
    line-height: 40px;
    text-indent:40px;
}
.mianfoot{
    width: 580px;
    height: 100px;
    display: flex;
    border-top: 1px solid #eaeaea;
    flex-direction: row;
    // justify-content: center;
    // align-items: center;
}
.mianfoot_text1{
    width: 290px;
    height: 100px;
    text-align: center;
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    line-height: 100px;
    border-right: 1px solid #eaeaea;

}
.mianfoot_text{
    width: 290px;
    height: 100px;
    text-align: center;
    font-size: 32px;
    font-weight: 400;
    line-height: 100px;
    color: #1740DA;
}

</style>